"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrubber = void 0;

var _react = _interopRequireWildcard(require("react"));

var momentjs = _interopRequireWildcard(require("moment"));

var _ = require("../..");

var _MomentRow = require("../MomentRow");

var _useFluidPlayer2 = require("./useFluidPlayer");

require("./Scrubber.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DEFAULT_DURATION = 120 * 60;

var Scrubber = function Scrubber(_ref) {
  var containerRef = _ref.containerRef;

  var _useState = (0, _react.useState)(window.innerWidth * 0.6),
      _useState2 = _slicedToArray(_useState, 2),
      rangeWidth = _useState2[0],
      setRangeWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(DEFAULT_DURATION),
      _useState4 = _slicedToArray(_useState3, 2),
      duration = _useState4[0],
      setDuration = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      rangeEl = _useState6[0],
      setRangeEl = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      hoveredMoment = _useState8[0],
      setHoveredMoment = _useState8[1];

  var isDragging = (0, _react.useRef)(false);

  var _useFluidPlayer = (0, _useFluidPlayer2.useFluidPlayer)(containerRef),
      items = _useFluidPlayer.items,
      jump = _useFluidPlayer.jump,
      fluidSourcesInfo = _useFluidPlayer.fluidSourcesInfo; // resize obnserver


  (0, _react.useEffect)(function () {
    var resizeObserver = new ResizeObserver(function (entries) {
      if (entries && entries.length > 0) {
        setRangeWidth(entries[0].contentRect.width);
      }
    });

    if (rangeEl) {
      resizeObserver.observe(rangeEl);
    }

    return function () {
      if (rangeEl) {
        resizeObserver.unobserve(rangeEl);
      }
    };
  }, [rangeEl]); // add/remove event listeners

  (0, _react.useEffect)(function () {
    // window.addEventListener("resize", setWindowDimensions)
    document.addEventListener("trc-video-info", onVideoUpdate);
    document.addEventListener("trc-video-info-loading", onVideoUpdate);
    return function () {
      // window.removeEventListener("resize", setWindowDimensions)
      document.removeEventListener("trc-video-info", onVideoUpdate);
      document.removeEventListener("trc-video-info-loading", onVideoUpdate);
    };
  }, [containerRef, rangeEl, rangeWidth, duration]);

  var onVideoUpdate = function onVideoUpdate(e) {
    // handle video size changes
    if (!rangeEl) {
      var rangeQuery = "#video-container-".concat(containerRef.current, " .range");
      var el = document.querySelector(rangeQuery);

      if (el) {
        setRangeEl(el);
      }
    } // handle updates


    var vi = e.detail;

    if (vi && vi.video_id && vi.video_id.includes(containerRef.current)) {
      if (vi.scrubber.duration !== duration) {
        setDuration(vi.scrubber.duration);
      }

      updateTime(vi.scrubber.currentTime);

      if (!isDragging.current) {
        positionThumb(vi.scrubber.currentTime);
        positionRangeMask(vi.scrubber.currentTime);
      }
    }
  };

  var rangeLines = (0, _react.useMemo)(function () {
    var _fluidSourcesInfo$fir, _fluidSourcesInfo$act;

    var lines = [];
    var firstStart = ((_fluidSourcesInfo$fir = fluidSourcesInfo.firstMainFluidSource) === null || _fluidSourcesInfo$fir === void 0 ? void 0 : _fluidSourcesInfo$fir.start_time) / 1000;
    var activeColor = "rgba(255, 255, 255, 0.5)";

    if ((fluidSourcesInfo === null || fluidSourcesInfo === void 0 ? void 0 : (_fluidSourcesInfo$act = fluidSourcesInfo.activeFluidSources) === null || _fluidSourcesInfo$act === void 0 ? void 0 : _fluidSourcesInfo$act.length) > 0) {
      var _iterator = _createForOfIteratorHelper(fluidSourcesInfo.activeFluidSources),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var fs = _step.value;
          var startTime = fs.start_time / 1000 - firstStart;
          var endTime = fs.start_time / 1000 - firstStart + fs.duration;
          var start = getXPercentForTime(startTime, {
            duration: duration
          });
          var end = getXPercentForTime(endTime, {
            duration: duration
          });
          var width = getWidthPercentForRange(startTime, endTime, {
            duration: duration
          });
          lines.push({
            id: fs.game_clip_id,
            color: activeColor,
            start: start,
            end: end,
            width: width
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return lines;
  }, [fluidSourcesInfo, duration]); // update position of thumb

  var positionThumb = function positionThumb(time) {
    var thumb = document.querySelector("#video-container-".concat(containerRef.current, " .Scrubber .thumb"));

    if (thumb) {
      var x = getXPercentForTime(time, {
        duration: duration
      });
      thumb.style.left = "calc(".concat(x, " - 8px)");
    }
  };

  var positionRangeMask = function positionRangeMask(time) {
    var left = document.querySelector("#video-container-".concat(containerRef.current, " .Scrubber .range #range-mask-left"));
    var right = document.querySelector("#video-container-".concat(containerRef.current, " .Scrubber .range #range-mask-right"));
    var x = getXPercentForTime(time, {
      duration: duration
    }); // update left

    left.setAttribute("width", x); // update right

    var w = getWidthPercentForRange(time, duration, {
      duration: duration
    });
    right.setAttribute("width", w);
    right.setAttribute("x", x);
  };

  var positionTimeHoverCard = function positionTimeHoverCard(visible, time) {
    if (rangeEl) {
      var cardEl = rangeEl.querySelector(".time-hover-card");

      if (visible) {
        var hasVideo = false;
        var firstSource = fluidSourcesInfo.firstMainFluidSource;
        var firstStart = (firstSource === null || firstSource === void 0 ? void 0 : firstSource.start_time) / 1000;

        var _iterator2 = _createForOfIteratorHelper(fluidSourcesInfo.activeFluidSources),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var source = _step2.value;
            var sourceStart = source.start_time / 1000 - firstStart;
            var sourceEnd = sourceStart + source.duration;

            if (sourceStart <= time && time <= sourceEnd) {
              hasVideo = true;
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var x = getXPercentForTime(time, {
          duration: duration
        });
        cardEl.style.display = "block";
        cardEl.style.left = x;

        if (hasVideo) {
          cardEl.style.width = "75px";
          cardEl.innerText = formatTime(time);
        } else {
          cardEl.style.width = "110px";
          cardEl.innerText = "No Video";
        }
      } else {
        cardEl.style.display = "none";
      }
    }
  };

  var positionTimelineCard = function positionTimelineCard(visible, time) {
    if (rangeEl) {
      var cardEl = rangeEl.querySelector(".timeline-hovercard");

      if (visible) {
        var x = getXPercentForTime(time, {
          duration: duration
        });
        cardEl.style.display = "block";
        cardEl.style.left = x;
      } else {
        cardEl.style.display = "none";
      }
    }
  };

  var updateTime = function updateTime(time) {
    if (rangeEl) {
      var query = "#video-container-".concat(containerRef.current, " .current-time");
      var timeDiv = document.querySelector(query);
      timeDiv.innerHTML = formatTime(time);
    }
  };

  var mouseDown = function mouseDown(e) {
    (0, _.log)("Scrubber", "mouseDown", e);
    isDragging.current = true;
  };

  var mouseUp = function mouseUp(e) {
    var mouseX = e.clientX;
    var time = getTimeForX(mouseX, {
      rangeEl: rangeEl,
      duration: duration
    });

    if (hoveredMoment) {
      var firstStart = fluidSourcesInfo.firstMainFluidSource.start_time / 1000;
      time = hoveredMoment.start_time - firstStart;
    }

    (0, _.log)("Scrubber", "mouseUp", "jump", time);
    jump(time);
    isDragging.current = false;
    (0, _.trackEvent)({
      action: "Video Scrubbed",
      element: e.target
    });
  };

  var mouseOut = function mouseOut(e) {
    (0, _.log)("Scrubber", "mouseOut", e);
    isDragging.current = false;
    (0, _.trackEvent)({
      action: "Video Scrubbed",
      element: e.target
    });
    setHoveredMoment(null);
    positionTimeHoverCard(false, 0);
    positionTimelineCard(false, 0);
  };

  var mouseMove = function mouseMove(e) {
    var mouseX = e.clientX;
    var time = getTimeForX(mouseX, {
      rangeEl: rangeEl,
      duration: duration
    });
    var utcTime = time + fluidSourcesInfo.firstMainFluidSource.start_time / 1000;

    if (isDragging.current) {
      positionThumb(time);
      positionRangeMask(time);
    }

    var currentTick = null;

    if (rangeEl && !(0, _.isLandscape)()) {
      var possibleTicks = [];
      var tickFuzz = duration / rangeEl.offsetWidth * 6;

      var _iterator3 = _createForOfIteratorHelper(ticks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _tick = _step3.value;

          if (_tick.start_time - tickFuzz <= utcTime && utcTime <= _tick.start_time + tickFuzz) {
            possibleTicks.push(_tick);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var bestDist = Number.MAX_SAFE_INTEGER;

      for (var _i2 = 0, _possibleTicks = possibleTicks; _i2 < _possibleTicks.length; _i2++) {
        var tick = _possibleTicks[_i2];
        var dist = Math.abs(utcTime - tick.start_time);

        if (dist < bestDist) {
          bestDist = dist;
          currentTick = tick;
        }
      }
    }

    if (currentTick) {
      if (currentTick.id !== (hoveredMoment === null || hoveredMoment === void 0 ? void 0 : hoveredMoment.id)) {
        setHoveredMoment(currentTick);
      }

      positionTimeHoverCard(false, time);
      positionTimelineCard(true, time);
    } else {
      if (hoveredMoment !== null) {
        setHoveredMoment(null);
      }

      positionTimeHoverCard(true, time);
      positionTimelineCard(false, time);
    }
  };

  var ticks = (0, _react.useMemo)(function () {
    var newTicks = [];
    var firstRawVideo = fluidSourcesInfo.firstMainFluidSource;
    if (!firstRawVideo) return newTicks;
    var tickColor = "#ffffff";

    var _iterator4 = _createForOfIteratorHelper(items),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var item = _step4.value;
        var moment = item.moment ? item.moment : item;
        var tick = {
          id: moment.game_clip_id,
          start_time: moment.start_time / 1000,
          end_time: moment.start_time / 1000 + moment.duration,
          tags: (0, _.generateHumanTags)(moment),
          away: moment.away_team,
          home: moment.home_team,
          players: moment.players
        };
        var goalTag = tick.tags.find(function (t) {
          return t.name === "goal";
        });
        tickColor = goalTag ? "var(--" + goalTag.background.replace("2", "1") + ")" : "#ffffff";
        var startTime = firstRawVideo.start_time / 1000;
        var opacity = 0.25;

        if ((hoveredMoment === null || hoveredMoment === void 0 ? void 0 : hoveredMoment.start_time) === tick.start_time || goalTag) {
          opacity = 1;
        }

        tick.x = getXPercentForTime(tick.start_time - startTime, {
          duration: duration
        });
        tick.end = getXPercentForTime(tick.end_time - startTime, {
          duration: duration
        });
        tick.y = (hoveredMoment === null || hoveredMoment === void 0 ? void 0 : hoveredMoment.id) === tick.id ? "2px" : "5px";
        tick.fill = tickColor;
        tick.opacity = opacity;
        tick.timeStart = formatTime(tick.start_time - startTime);
        tick.timeEnd = formatTime(tick.end_time - startTime);
        newTicks.push(tick);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    return newTicks;
  }, [items, fluidSourcesInfo, hoveredMoment, duration]);
  return /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "Scrubber"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    padding: "0 4 0 0",
    marginRight: "4",
    className: "current-time",
    type: _.Label.Type.Body,
    color: _.Color.White1,
    small: true,
    width: 48,
    content: "--:--"
  }), /*#__PURE__*/_react.default.createElement(_.Element, {
    span: "10",
    className: "range",
    onMouseMove: mouseMove,
    onMouseDown: mouseDown,
    onMouseUp: mouseUp,
    onMouseOut: mouseOut
  }, /*#__PURE__*/_react.default.createElement(_.Element, {
    id: "timeline-hovercard",
    marginBottom: "8",
    className: "timeline-hovercard"
  }, /*#__PURE__*/_react.default.createElement(_MomentRow.MomentAvatars, {
    name: "avatars",
    avatarSize: "40",
    players: hoveredMoment ? hoveredMoment.players : [],
    marginBottom: "2"
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "tags",
    type: _.Label.Type.Body,
    content: (hoveredMoment ? hoveredMoment.tags : []).filter(function (tag) {
      return tag.title !== "TraceCam";
    }).map(function (t) {
      return t.title;
    }).join(", ")
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    type: _.Label.Type.Body,
    content: "".concat(hoveredMoment ? hoveredMoment.timeStart : "00", " - ").concat(hoveredMoment ? hoveredMoment.timeEnd : "00")
  })), /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "time-hover-card",
    marginBottom: 8
  }), /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    width: "100%",
    height: "40px",
    viewBox: "0 0 ".concat(rangeWidth, " 40")
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "round-corner"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "19",
    width: "100%",
    height: "4",
    rx: "2",
    ry: "2"
  })), /*#__PURE__*/_react.default.createElement("mask", {
    id: "range-mask",
    x: "0",
    y: "0",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    id: "range-mask-left",
    height: "100%",
    fill: "white",
    x: "0%",
    width: "0%"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    id: "range-mask-right",
    height: "100%",
    fill: "black",
    x: "0%",
    width: "100%"
  }))), ticks.map(function (tick) {
    return /*#__PURE__*/_react.default.createElement("circle", {
      key: "circle-".concat(tick.id),
      cx: tick.x,
      cy: tick.y,
      r: "2px",
      fill: tick.fill,
      opacity: tick.opacity
    });
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#ff0000",
    x: "0",
    y: "0",
    height: "100%",
    width: "100%",
    rx: "4px",
    ry: "4px",
    opacity: "0"
  }), rangeLines.map(function (line) {
    return /*#__PURE__*/_react.default.createElement("g", {
      key: "range-".concat(line.id)
    }, /*#__PURE__*/_react.default.createElement("rect", {
      x: line.start,
      y: "18",
      width: line.width,
      opacity: "1",
      fill: "white",
      height: "8",
      className: "svg-range",
      mask: "url(#range-mask)",
      clipPath: "url(#round-corner)"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: line.start,
      y: "18",
      width: line.width,
      opacity: ".6",
      fill: line.color,
      height: "8",
      className: "svg-range"
    }));
  })), /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "thumb"
  })));
};

exports.Scrubber = Scrubber;

var getTimeForX = function getTimeForX(x, _ref2) {
  var rangeEl = _ref2.rangeEl,
      duration = _ref2.duration;

  if (rangeEl) {
    var clientRect = rangeEl.getBoundingClientRect();
    var xx = x - clientRect.left;
    var xMin = clientRect.left;
    var xMax = clientRect.right;
    var length = xMax - xMin;
    var pxr = duration / length;
    return xx * pxr;
  } else {
    return 0;
  }
};

var getXPercentForTime = function getXPercentForTime(time, _ref3) {
  var duration = _ref3.duration;

  if (duration > 0) {
    var pxr = 100 / duration;
    var p = time * pxr;

    if (p > 100) {
      p = 100;
    }

    if (p < 0) {
      p = 0;
    }

    return "".concat(Math.round(p * 100) / 100, "%");
  } else {
    return "0%";
  }
};

var getWidthPercentForRange = function getWidthPercentForRange(start, end, _ref4) {
  var duration = _ref4.duration;

  if (duration > 0) {
    var rangeDur = end - start;
    var pxr = 100 / duration;
    var p = rangeDur * pxr;

    if (p > 100) {
      p = 100;
    }

    if (p < 0) {
      p = 0;
    }

    return "".concat(Math.round(p * 100) / 100, "%");
  } else {
    return "0%";
  }
};

var formatTime = function formatTime(time) {
  var ft = "--:--";
  var fgt = 0;
  var t = momentjs.duration((time + fgt) * 1000);
  var minutes = Math.floor(t.asMinutes());
  t.subtract(minutes, "minutes");
  var seconds = Math.floor(t.seconds());
  ft = minutes < 10 ? "0" : "";
  ft += minutes;
  ft += ":";
  ft += seconds < 10 ? "0" : "";
  ft += seconds;
  return ft;
};